import Storage from "./storage";
import ITranslation from "../interface/translation";
import ILanguage from "../interface/language";
import Global from "../global";
import StorageItem from "../enum/storage-item";
import ErrorCode from "../enum/error-code";
import Translations from "../data/translations";

class LanguageSingleton {

    public getAll(): ILanguage[] {
        return Translations.map((t: ITranslation) => { return { id: t.id, name: t.name }; });
    }

    public get(): string {
        const saved: string | null = Storage.getItem(StorageItem.Language);
        if (saved) {
            return saved;
        } else {
            const id: string = this.getLocale();
            const lang: ITranslation | null = this.getTranslation(id);
            if (lang) {
                return lang.id;
            }
            return Global.DEFAULT_LANGUAGE;
        }
    }

    public set(id: string): string {
        const lang: ITranslation | null = this.getTranslation(id);
        if (lang) {
            Storage.setItem(StorageItem.Language, lang.id);
            return id;
        } else {
            throw ErrorCode.BadArguments;
        }
    }

    public getLocale(): string {
        return navigator.language.split(/[-_]/)[0];
    }

    public getTranslation(id: string): ITranslation | null {
        return Translations.find((t: ITranslation) => t.id === id) || null;
    }

}

const Language = new LanguageSingleton();

export default Language;